import { render, staticRenderFns } from "./TaskEditContractor.vue?vue&type=template&id=31fb9abb&"
import script from "./TaskEditContractor.vue?vue&type=script&lang=js&"
export * from "./TaskEditContractor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports